import AppLayout from '../../components/AppLayout';
import { Link } from 'react-router';
import { FaPlus } from 'react-icons/fa';
import { useEvents } from '../../queries/EventQueries';
import ShowPending from '../../components/ShowPending';
import ShowError from '../../components/ShowError';
import EventTable from '../../components/EventTable';

export default function Events() {
  const { isPending, isError, data, error } = useEvents();
  return (
    <AppLayout>
      <div className='mb-8 w-full'>
        <div className='flex items-start justify-center'>
          <h3 className='text-center text-2xl dark:text-gray-300'>Events</h3>
          <Link
            to='/add-event'
            className='ml-4 p-1 text-xs font-bold uppercase hover:opacity-70'
          >
            <div className='flex items-center gap-2'>
              <FaPlus /> Add
            </div>
          </Link>
        </div>
        <ShowPending isPending={isPending} />
        <ShowError isError={isError} error={error} />
        {data && <EventTable events={data} key={data.length} />}
      </div>
    </AppLayout>
  );
}
